import React from 'react';

interface Props {
  text: string;
  separator: number;
}

class Truncate extends React.Component<Props> {
  static defaultProps = {
    separator: 12,
  };

  render(): React.ReactNode {
    const { text, separator } = this.props;
    const sep = text.length - separator;

    const start = text.substring(0, sep);
    const end = text.substring(sep, text.length);
    return (
      <div className="row flex-nowrap justify-start">
        <span className="oh ellipsis nowrap shrink-1">{start}</span>
        <span
          style={{
            whiteSpace: 'nowrap',
            flexBasis: 'content',
            flexGrow: 0,
            flexShrink: 0,
          }}
        >
          {end}
        </span>
      </div>
    );
  }
}

export default Truncate;
